import React from "react";
import cx from "classnames";

import "./BreakdownSectionTitle.scss";

export interface IBreakdownSectionTitleProps {
  aside?: React.JSX.Element | string;
  isPrintView?: boolean;
}

const renderAside = (props: IBreakdownSectionTitleProps) => (
  <span>{props.aside}</span>
);

const BreakdownSectionTitle: React.FC<
  React.PropsWithChildren<IBreakdownSectionTitleProps>
> = (props) => (
  <div
    className={cx("c-breakdown-section-title", {
      "c-breakdown-section-title--print": props.isPrintView,
    })}
  >
    <h3>{props.children}</h3>
    {props.aside && renderAside(props)}
  </div>
);

export default BreakdownSectionTitle;
